// src/components/ApplicationForm.jsx
import React, { useState } from 'react';

const ApplicationForm = () => {
  const [form, setForm] = useState({
    fullName: '',
    email: '',
    linkedIn: '',
    idea: '',
    track: 'fashion',
    logo: null,
    mediaPlan: null,
    video: null
  });

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };

  const handleFileChange = e => {
    const { name, files } = e.target;
    setForm(f => ({ ...f, [name]: files[0] }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    console.log('Submitting application:', form);
    alert('Заявка успешно отправлена!');
    setForm({
      fullName: '',
      email: '',
      linkedIn: '',
      idea: '',
      track: 'fashion',
      logo: null,
      mediaPlan: null,
      video: null
    });
  };

  return (
    <section id='application' className="application">
      <div className="container">
        <h2 className="application__heading">Подать заявку</h2>
        <form className="application__form" onSubmit={handleSubmit}>
          <div className="application__field">
            <label htmlFor="fullName">ФИО капитана</label>
            <input
              id="fullName"
              name="fullName"
              type="text"
              required
              value={form.fullName}
              onChange={handleChange}
            />
          </div>

          <div className="application__field">
            <label htmlFor="email">E-mail</label>
            <input
              id="email"
              name="email"
              type="email"
              required
              value={form.email}
              onChange={handleChange}
            />
          </div>

          <div className="application__field">
            <label htmlFor="linkedIn">LinkedIn</label>
            <input
              id="linkedIn"
              name="linkedIn"
              type="url"
              placeholder="https://..."
              value={form.linkedIn}
              onChange={handleChange}
            />
          </div>

          <div className="application__field">
            <label htmlFor="idea">Идея бренда (до 1000 зн.)</label>
            <textarea
              id="idea"
              name="idea"
              rows="4"
              maxLength={1000}
              required
              value={form.idea}
              onChange={handleChange}
            />
          </div>

          {/* <div className="application__field">
            <label htmlFor="track">Трек</label>
            <select
              id="track"
              name="track"
              value={form.track}
              onChange={handleChange}
            >
              <option value="fashion">Fashion & Lifestyle</option>
              <option value="tech">Digital Innovation</option>
              <option value="social">Social Impact</option>
            </select>
          </div> */}

          <div className="application__field">
            <label htmlFor="logo">Логотип (SVG/PNG, ≤ 2 МБ)</label>
            <input
              id="logo"
              name="logo"
              type="file"
              accept=".svg,.png"
              onChange={handleFileChange}
            />
          </div>

          <div className="application__field">
            <label htmlFor="mediaPlan">Медиаплан (PDF, ≤ 5 МБ)</label>
            <input
              id="mediaPlan"
              name="mediaPlan"
              type="file"
              accept=".pdf"
              onChange={handleFileChange}
            />
          </div>

          <div className="application__field">
            <label htmlFor="video">Видео-обращение (MP4, ≤ 100 МБ)</label>
            <input
              id="video"
              name="video"
              type="file"
              accept=".mp4"
              onChange={handleFileChange}
            />
          </div>

          <div className="nominations__cont-btn">
            <button type="submit" className="application__submit-btn">
              Отправить заявку
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default ApplicationForm;
